import type { FormConfig } from '@workwave-tidal/form-fairy'
import type { FormErrors, FormFields } from '../../../formFields'
import type { ValidationTexts } from '../useTexts'

import { useValidateEmail } from '@/hooks'
import { useAppDispatch } from '@/store'

import { createValidateEligibility } from './createValidateEligibility'
import { createValidateEmail } from './createValidateEmail'
import { createValidateLoads } from './createValidateLoads'
import { createValidateNotes } from './createValidateNotes'
import { createValidatePhone } from './createValidatePhone'
import { createValidateServiceTimeSec } from './createValidateServiceTimeSec'
import { createValidateTimeWindows } from './createValidateTimeWindows'

type Dispatch = ReturnType<typeof useAppDispatch>
type ValidateEmail = ReturnType<typeof useValidateEmail>

export function createValidations(
  texts: ValidationTexts,
  workingDayStartSec: number,
  dispatch: Dispatch,
  validateEmail: ValidateEmail,
): FormConfig<FormFields, FormErrors>['validations'] {
  return [
    {
      id: 'loads',
      fields: 'loads',
      validator: createValidateLoads(texts),
    },
    {
      id: 'serviceTimeSec',
      fields: 'serviceTimeSec',
      validator: createValidateServiceTimeSec(texts),
    },
    {
      id: 'timeWindows',
      fields: 'timeWindows',
      validator: createValidateTimeWindows(texts, workingDayStartSec),
    },
    {
      id: 'eligibility',
      fields: 'eligibility',
      validator: createValidateEligibility(texts),
    },
    {
      id: 'phone',
      fields: 'phone',
      validator: createValidatePhone(dispatch, texts),
    },
    {
      id: 'email',
      fields: 'email',
      validator: createValidateEmail(texts, validateEmail),
    },
    {
      id: 'notes',
      fields: 'notes',
      validator: createValidateNotes(texts),
    },
  ]
}
